/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_MakeInputs */

const en_field_make = /** @type {(inputs: Field_MakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make`)
};

const es_field_make = /** @type {(inputs: Field_MakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marca/Fabricante`)
};

const fr_field_make = /** @type {(inputs: Field_MakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marque`)
};

const de_field_make = /** @type {(inputs: Field_MakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marke/Hersteller`)
};

const ja_field_make = /** @type {(inputs: Field_MakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メーカー/ブランド`)
};

const zh_field_make = /** @type {(inputs: Field_MakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`品牌/制造`)
};

const ar_field_make = /** @type {(inputs: Field_MakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الشركة المصنعة`)
};

const id_field_make = /** @type {(inputs: Field_MakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merek/Buatan`)
};

const it_field_make = /** @type {(inputs: Field_MakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marca/Produttore`)
};

const ru_field_make = /** @type {(inputs: Field_MakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Марка/Производитель`)
};

const pt_field_make = /** @type {(inputs: Field_MakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marca/Fabricante`)
};

const ko_field_make = /** @type {(inputs: Field_MakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`제조사/브랜드`)
};

/**
* | output |
* | --- |
* | "Make" |
*
* @param {Field_MakeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_make = /** @type {((inputs?: Field_MakeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_MakeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_make(inputs)
	if (locale === "es") return es_field_make(inputs)
	if (locale === "fr") return fr_field_make(inputs)
	if (locale === "de") return de_field_make(inputs)
	if (locale === "ja") return ja_field_make(inputs)
	if (locale === "zh") return zh_field_make(inputs)
	if (locale === "ar") return ar_field_make(inputs)
	if (locale === "id") return id_field_make(inputs)
	if (locale === "it") return it_field_make(inputs)
	if (locale === "ru") return ru_field_make(inputs)
	if (locale === "pt") return pt_field_make(inputs)
	return ko_field_make(inputs)
});